module.exports = __webpack_public_path__ + "static/assets/0d34c80e3919306cb722380e920cffac.png";